import { srHide } from '../utils/srVisibility'

export default {
  name: 'cookie-banner',

  ui: {
    agreeButton: '[js-cookie-banner-agree]',
  },

  events: [
    {
      target: 'agreeButton',
      on: 'click',
      handle () {
        window['ga-disable-UA-108092805-2'] = false
        srHide(this.el)
        // If this one expires, I'll eat my chapeau.
        document.cookie = `acceptCookies=true; expires=Tue, 19 Jan 2038 00:00:00 UTC;`
      },
    },
  ],

  componentDidMount () {
    if (document.cookie.includes('acceptCookies')) {
      this.el.remove()
    } else {
      this.el.classList.remove('is-hidden')
      window['ga-disable-UA-108092805-2'] = true
    }
  },
}
